import { render, staticRenderFns } from "./GameTypeForm.vue?vue&type=template&id=2c214554&"
import script from "./GameTypeForm.vue?vue&type=script&lang=js&"
export * from "./GameTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports